module.exports = __webpack_public_path__ + "img/icon-tickets.ead1e8a0.svg";